export enum UserVisit {
    synthesis = 'synthesis', //click on synthesis button on support screen
    support = 'support', //click on support button on support screen
    socialize = 'socialize', //click on socialize button of home screen or sapphics screen
    join_chat = 'join_chat', //click on join any chat button
    standings = 'standings', //results screen click on standings button
    stats = 'stats', //results screen click on stats button
    scores = 'scores', //results screen click on scores button
    sapphics = 'sapphics', //click on sapphics icon on nav panel (central icon)
    shape = 'shape', //click on shape button on home screen
    minigames = 'minigames', //click on minigames button on home screen
    app = 'app', //app comes to foreground or app is opened
}
